import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["type", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_3 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_4 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      id: 'buttonComponent',
      class: _normalizeClass(_ctx.buttonClasses),
      type: _ctx.type,
      disabled: _ctx.disabled || _ctx.loading || !_ctx.connectionState,
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
                _ctx.icon === 'tg' ? _ctx.$emit('openTelegram') : _ctx.$emit('clickAction')

      ), ["stop"]))
    }, [
      (_ctx.loading || !_ctx.connectionState)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createElementVNode("svg", {
              class: "inline h-6 w-6 animate-spin text-grey",
              viewBox: "0 0 100 101",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                fill: "#fcfcfc"
              }),
              _createElementVNode("path", {
                d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                fill: "currentColor"
              })
            ], -1)),
            (_ctx.disabledText)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.disabledText), 1))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.icon)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: require(`@/assets/img/general/${_ctx.icon}.svg`),
                        class: "mr-2 w-[24px] h-[24px]",
                        alt: ""
                      }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _renderSlot(_ctx.$slots, "title")
                ]))
          ], 64))
    ], 10, _hoisted_1)
  ]))
}